import { Head, Link, useForm } from "@inertiajs/react"

import AppLayout from "@/layouts/app-layout"
import type { BreadcrumbItem } from "@/types"

interface Props {
  todo_category: {
    id: number
    name: string
  }
  errors?: Record<string, string[]>
}

export default function Edit({ todo_category, errors }: Props) {
  const breadcrumbs: BreadcrumbItem[] = [
    { title: "Manage", href: "/admin/todo_categories" },
    { title: "Todo Categories", href: "/admin/todo_categories" },
    { title: "Edit", href: `/admin/todo_categories/${todo_category.id}/edit` },
  ]

  const { data, setData, patch, processing, transform } = useForm({
    name: todo_category.name,
  })

  transform((data) => ({ todo_category: data }))

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    patch(`/admin/todo_categories/${todo_category.id}`)
  }

  return (
    <AppLayout breadcrumbs={breadcrumbs}>
      <Head title="Edit Todo Category" />

      <div className="p-6">
        <h1 className="mb-4 text-2xl font-semibold">Update Category</h1>

        <form onSubmit={handleSubmit} className="max-w-md">
          <div className="mb-4">
            <label htmlFor="name" className="mb-1 block font-medium">
              Name
            </label>
            <input
              type="text"
              id="name"
              value={data.name}
              onChange={(e) => setData("name", e.target.value)}
              className="border-hpi-light-gray w-full rounded border px-3 py-2"
              maxLength={50}
            />
            {errors?.name && (
              <p className="text-hpi-red mt-1 text-sm">
                {errors.name.join(", ")}
              </p>
            )}
          </div>

          <div className="flex gap-2">
            <button
              type="submit"
              disabled={processing}
              className="bg-hpi-dark-blue hover:bg-hpi-blue rounded px-4 py-2 text-white disabled:opacity-50"
            >
              Save
            </button>
            <Link
              href="/admin/todo_categories"
              className="border-hpi-light-gray hover:bg-hpi-pale-blue rounded border px-4 py-2"
            >
              Cancel
            </Link>
          </div>
        </form>
      </div>
    </AppLayout>
  )
}
